import { axios } from "src/common/utils";
import { appSettings } from "src/configs";
import { commonHeader, authHeader } from "src/common/requestHeader";

const NoticeVesselService = {};

NoticeVesselService.vesselNomination = () => {
    return new Promise((resolve, reject) => {
        axios({
            headers: {
                ...commonHeader(),
                ...authHeader(),
                Pragma: "no-cache",
            },
            method: "get",
            url: `${appSettings.services.map.apiUrl}/api/v1.0/NoticeVessel`,
            params: {},
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
};

NoticeVesselService.vesselAdd = (formData) => {
    return new Promise((resolve, reject) => {
        axios({
            headers: {
                ...commonHeader(),
                ...authHeader(),
                Pragma: "no-cache",
            },
            method: "post",
            url: `${appSettings.services.map.apiUrl}/api/v1.0/NoticeVessel`,
            params: {},
            data: { ...formData }
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
};


NoticeVesselService.vesselUpdate = (formData) => {
    return new Promise((resolve, reject) => {
        axios({
            headers: {
                ...commonHeader(),
                ...authHeader(),
                Pragma: "no-cache",
            },
            method: "put",
            url: `${appSettings.services.map.apiUrl}/api/v1.0/NoticeVessel`,
            params: {},
            data: { ...formData }
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
};

NoticeVesselService.getVesselId = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            headers: {
                ...commonHeader(),
                ...authHeader(),
                Pragma: "no-cache",
            },
            method: "get",
            url: `${appSettings.services.map.apiUrl}/api/v1.0/NoticeVessel/${id}`,
            params: {},
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
};


NoticeVesselService.getVesselLength = (id) => {
    return new Promise((resolve, reject) => {
        axios({
            headers: {
                ...commonHeader(),
                ...authHeader(),
                Pragma: "no-cache",
            },
            method: "get",
            url: `${appSettings.services.map.apiUrl}/api/v1.0/NoticeVessel/Length`,
            params: {},
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
};

NoticeVesselService.deleteVessel = (formData) => {
    return new Promise((resolve, reject) => {
        axios({
            headers: {
                ...commonHeader(),
                ...authHeader(),
            },
            method: "delete",
            url: `${appSettings.services.map.apiUrl}/api/v1.0/NoticeVessel`,
            params: {},
            data: { ...formData }
        })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
    });
};

export default NoticeVesselService;
